/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
  // Add custom code below this line
  
  // Select the target node (the element to observe)
  const desktopCartCounter = document.getElementById('desktop_cart_counter');
  const mobCartCounter = document.getElementById('mob_cart_counter');

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
              // Update mob_cart_counter text to match desktop_cart_counter
              mobCartCounter.textContent = desktopCartCounter.textContent;
          }
      }
  });

  // Configuration of the observer:
  const config = { childList: true, characterData: true, subtree: true };

  // Start observing the target node for configured mutations
  observer.observe(desktopCartCounter, config);

  // Debugging: Log changes to observe if the mutation is being detected
  desktopCartCounter.addEventListener('DOMSubtreeModified', () => {
      console.log('desktop_cart_counter modified:', desktopCartCounter.textContent);
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.


document.addEventListener("DOMContentLoaded", function() {
  const tabLinks = document.querySelectorAll(".col-tab-link");
  const tabContents = document.querySelectorAll(".tab-collection");

  tabLinks.forEach(function(link) {
    link.addEventListener("click", function(e) {
      e.preventDefault();

      tabLinks.forEach(function(link) {
        link.classList.add("as-col-nav");
        link.classList.remove("as-underline");
        link.classList.add("as-text-[#9F9F9F]");
        link.classList.remove("as-text-[#000]");
      });

      this.classList.remove("as-col-nav");
      this.classList.add("as-underline");
      this.classList.remove("as-text-[#9F9F9F]");
      this.classList.add("as-text-[#000]");
      
      const targetId = this.getAttribute("data-target");
      if (!targetId) return; // If no data-target attribute, exit
      
      tabContents.forEach(function(tabContent) {
        tabContent.classList.add("as-hidden");
      });

      const targetTab = document.getElementById(targetId);
      if (targetTab) {
        targetTab.classList.remove("as-hidden");
      }
    });
  });
});

document.addEventListener('click', function(event) {
  // Check if the clicked element matches '.select-popout__option'
  if (event.target.closest('.select-popout__option')) {
      // Find the span[data-qty-text] within the clicked element
      const qtyTextElement = event.target.closest('.select-popout__option').querySelector('span[data-qty-text]');
      const qtyText = qtyTextElement ? qtyTextElement.textContent : '';

      // Set the text of the '#qty-text' element
      const targetElement = document.querySelector('#qty-text');
      if (targetElement) {
          targetElement.textContent = qtyText;
      }
  }
});

